import React from 'react'
import { useSelector } from 'react-redux'
import { ReactComponent as DailyGoalBadge } from 'resources/graphics/achievements-icons/daily_goal_badge.svg'
import { selectDailyGoal, selectProgressPercentage, selectTimeSpent } from 'store/services/Library'
import { Progress } from 'components/Progress'

import './StudyGoalTimer.scss'

export function StudyGoalTimer() {
  const timeSpent = useSelector(selectTimeSpent)
  const dailyGoal = useSelector(selectDailyGoal)
  const dailyProgress = useSelector(selectProgressPercentage)

  return (
    <div className="goal">
      <div className="goal__container">
        <Progress
          progress={dailyProgress}
          placeholder={`${timeSpent} min`}
          ariaLabel={`Daily study progress ${timeSpent} of ${dailyGoal} minutes`}
        />
        <DailyGoalBadge className="goal__badge" aria-hidden="true" focusable="false" />
      </div>
      <span className="goal__target">{dailyGoal} min</span>
    </div>
  )
}
